import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faTableCells } from "@fortawesome/free-solid-svg-icons";
import "../../../Styles/components/view-toggle.scss";

export default function ViewToggle({
  value = "grid",
  onChange,
  className = "",
  showList = true,
  showGrid = true,
  disabled = false,
  ariaLabel = "Change view",
}) {
  if (!showList && !showGrid) return null;

  return (
    <div
      className={["view-toggle", className].filter(Boolean).join(" ")}
      role="group"
      aria-label={ariaLabel}
    >
      {showList ? (
        <button
          type="button"
          className={`view-toggle__button ${value === "list" ? "is-active" : ""}`}
          aria-pressed={value === "list"}
          aria-label="List view"
          disabled={disabled}
          onClick={() => onChange?.("list")}
        >
          <FontAwesomeIcon icon={faList} />
        </button>
      ) : null}

      {showGrid ? (
        <button
          type="button"
          className={`view-toggle__button ${value === "grid" ? "is-active" : ""}`}
          aria-pressed={value === "grid"}
          aria-label="Grid view"
          disabled={disabled}
          onClick={() => onChange?.("grid")}
        >
          <FontAwesomeIcon icon={faTableCells} />
        </button>
      ) : null}
    </div>
  );
}

